module.exports = new __parcel__URL__("crystalshield.b5476743.png").toString();